module.exports = __webpack_public_path__ + "static/media/OM.d3f58ec5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/OM.svg
// module id = 334
// module chunks = 0